// extracted by mini-css-extract-plugin
export var radioInputRow = "C_tZ";
export var radioInputColumn = "C_t0";
export var inputOptionRow = "C_qq";
export var inputOptionColumn = "C_qr";